import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Interestingly, in the picture you see a tactic that is used for
                                                survival. In today’s globalised and technological corporate
                                                world, it is important for organisations to have a strong team
                                                identity to stay ahead of competitors and reach their consumers.
                                                This tool is about <span className="brown  brownbold">how to create team identity</span> and
                                                will assist you in understanding the factors behind building
                                                cohesion in your team.</p>


                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>WHO AM I?</div>
                                            <p>Understanding your team is fundamental to getting the best from
                                                it, because your knowledge of its members’ different skills and
                                                preferred methods of working will enable each to play to his or
                                                her strengths and overcome weaknesses.</p>
                                            <div className="border_subtitle">Who am I? Social Identity Theory
                                                (SIT)<a className="superscripttext boldlink"
                                                        href="further_info.php?course=300"><sup>2</sup></a>
                                            </div>
                                            <p>There has been a large amount of research since the 1970s into
                                                how people identify themselves in a social context, with much of
                                                it coming under the label of ‘Social Identity Theory’. In work
                                                environments how people do this can be of great importance
                                                because social interaction is key to an integrated and
                                                productive workforce. While many managers can be perfectly aware
                                                of the
                                                skills and traits of their workers, for example who is a ‘team
                                                player’ and who works better on their own, understanding their
                                                identity can often take a back seat.</p>
                                            <p>In a modern piece of research<a className="superscripttext"
                                                                               href="further_info.php?course=300"><sup>3</sup></a> psychologists
                                                briefed participants who were either assigned to an imaginary
                                                team with strong definitions or one with weak definitions. Those
                                                who had strong
                                                definitions were more likely to identify with the theoretical
                                                group; additionally, they believed those in the group were like
                                                themselves, and looked more favourably on their actions. This
                                                was
                                                regardless of the ethnic, gender or any other group identity of
                                                the participant.</p>
                                            <p>To summarise, ‘Social Identity Theory’ reveals that in
                                                successfully functioning groups, a shared identity provides
                                                cohesion amongst otherwise separate and different people.
                                                Obvious examples
                                                of ‘group identity’ include nationalities, cultures, religions
                                                and so on. And the people in your team are also a group, whose
                                                success depends on how strongly they feel about that – or
                                                whether they
                                                think they’re a team at all.</p>
                                            <div className="border_subtitle">Who am I at the moment?
                                                Self-Categorisation Theory (SCT)<a
                                                    className="superscripttext boldlink"
                                                    href="further_info.php?course=300"><sup>4</sup></a></div>
                                            <p>Simply, this is an individual’s choice to behave according to his
                                                or her personal identity, or that of
                                                a group’s ‘shared identity’. Influencing factors will include
                                                what regard someone has for the group
                                                concerned, or how membership of it enhances self-esteem or
                                                conveys other benefits.</p>
                                            <p>We’ve very briefly summarised two theories, so that when you
                                                create a team, or consider one
                                                which is already operational, you may have a better
                                                understanding of group formation and identity,
                                                and its possible impact on its members.</p>
                                            <p>Next, we’ll describe a model for creating team identity and
                                                practical steps for managing
                                                its various aspects.</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">CREATING TEAM IDENTITY</span>
                                            </div>

                                            <div className="border_subtitle">The Pearn Kandola model of creating
                                                team identity
                                            </div>
                                            <p>Simply bringing a group of people together and calling them a
                                                team doesn’t make them one. They need to develop mutual trust,
                                                cooperation, support and commitment – in other words, a shared
                                                identity. If you can’t identify ways in which your team is
                                                different from other groups in the organisation, it has no
                                                identity.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }